import Localized from 'react-localization';

const images = new Localized({
  en: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/en/web_01.jpg'),
    web_02: require('./images/en/web_02.jpg'),
    web_03: require('./images/en/web_03.jpg'),
    web_04: require('./images/en/web_04.jpg'),
    web_05: require('./images/en/web_05.jpg'),
    web_06: require('./images/en/web_06.jpg'),
    web_07: require('./images/en/web_07.jpg'),
    web_08: require('./images/en/web_08.jpg'),
    web_09: require('./images/en/web_09.jpg'),
    web_10: require('./images/en/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
  ko: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/ko/web_01.jpg'),
    web_02: require('./images/ko/web_02.jpg'),
    web_03: require('./images/ko/web_03.jpg'),
    web_04: require('./images/ko/web_04.jpg'),
    web_05: require('./images/ko/web_05.jpg'),
    web_06: require('./images/ko/web_06.jpg'),
    web_07: require('./images/ko/web_07.jpg'),
    web_08: require('./images/ko/web_08.jpg'),
    web_09: require('./images/ko/web_09.jpg'),
    web_10: require('./images/ko/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
  ja: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/ja/web_01.jpg'),
    web_02: require('./images/ja/web_02.jpg'),
    web_03: require('./images/ja/web_03.jpg'),
    web_04: require('./images/ja/web_04.jpg'),
    web_05: require('./images/ja/web_05.jpg'),
    web_06: require('./images/ja/web_06.jpg'),
    web_07: require('./images/ja/web_07.jpg'),
    web_08: require('./images/ja/web_08.jpg'),
    web_09: require('./images/ja/web_09.jpg'),
    web_10: require('./images/ja/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
  zh: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/zh/web_01.jpg'),
    web_02: require('./images/zh/web_02.jpg'),
    web_03: require('./images/zh/web_03.jpg'),
    web_04: require('./images/zh/web_04.jpg'),
    web_05: require('./images/zh/web_05.jpg'),
    web_06: require('./images/zh/web_06.jpg'),
    web_07: require('./images/zh/web_07.jpg'),
    web_08: require('./images/zh/web_08.jpg'),
    web_09: require('./images/zh/web_09.jpg'),
    web_10: require('./images/zh/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
  de: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/en/web_01.jpg'),
    web_02: require('./images/en/web_02.jpg'),
    web_03: require('./images/en/web_03.jpg'),
    web_04: require('./images/en/web_04.jpg'),
    web_05: require('./images/en/web_05.jpg'),
    web_06: require('./images/en/web_06.jpg'),
    web_07: require('./images/en/web_07.jpg'),
    web_08: require('./images/en/web_08.jpg'),
    web_09: require('./images/en/web_09.jpg'),
    web_10: require('./images/en/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
  es: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/en/web_01.jpg'),
    web_02: require('./images/en/web_02.jpg'),
    web_03: require('./images/en/web_03.jpg'),
    web_04: require('./images/en/web_04.jpg'),
    web_05: require('./images/en/web_05.jpg'),
    web_06: require('./images/en/web_06.jpg'),
    web_07: require('./images/en/web_07.jpg'),
    web_08: require('./images/en/web_08.jpg'),
    web_09: require('./images/en/web_09.jpg'),
    web_10: require('./images/en/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
  fr: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/en/web_01.jpg'),
    web_02: require('./images/en/web_02.jpg'),
    web_03: require('./images/en/web_03.jpg'),
    web_04: require('./images/en/web_04.jpg'),
    web_05: require('./images/en/web_05.jpg'),
    web_06: require('./images/en/web_06.jpg'),
    web_07: require('./images/en/web_07.jpg'),
    web_08: require('./images/en/web_08.jpg'),
    web_09: require('./images/en/web_09.jpg'),
    web_10: require('./images/en/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
  hi: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/en/web_01.jpg'),
    web_02: require('./images/en/web_02.jpg'),
    web_03: require('./images/en/web_03.jpg'),
    web_04: require('./images/en/web_04.jpg'),
    web_05: require('./images/en/web_05.jpg'),
    web_06: require('./images/en/web_06.jpg'),
    web_07: require('./images/en/web_07.jpg'),
    web_08: require('./images/en/web_08.jpg'),
    web_09: require('./images/en/web_09.jpg'),
    web_10: require('./images/en/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
  it: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/en/web_01.jpg'),
    web_02: require('./images/en/web_02.jpg'),
    web_03: require('./images/en/web_03.jpg'),
    web_04: require('./images/en/web_04.jpg'),
    web_05: require('./images/en/web_05.jpg'),
    web_06: require('./images/en/web_06.jpg'),
    web_07: require('./images/en/web_07.jpg'),
    web_08: require('./images/en/web_08.jpg'),
    web_09: require('./images/en/web_09.jpg'),
    web_10: require('./images/en/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
  pt: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/en/web_01.jpg'),
    web_02: require('./images/en/web_02.jpg'),
    web_03: require('./images/en/web_03.jpg'),
    web_04: require('./images/en/web_04.jpg'),
    web_05: require('./images/en/web_05.jpg'),
    web_06: require('./images/en/web_06.jpg'),
    web_07: require('./images/en/web_07.jpg'),
    web_08: require('./images/en/web_08.jpg'),
    web_09: require('./images/en/web_09.jpg'),
    web_10: require('./images/en/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
  ru: {
    download_appstore: require('./images/download_appstore.png'),
    download_playstore: require('./images/download_playstore.png'),
    graphic: require('./images/graphic.png'),
    ic_app: require('./images/ic_app.png'),
    ic_instagram: require('./images/ic_instagram.png'),
    web_01: require('./images/en/web_01.jpg'),
    web_02: require('./images/en/web_02.jpg'),
    web_03: require('./images/en/web_03.jpg'),
    web_04: require('./images/en/web_04.jpg'),
    web_05: require('./images/en/web_05.jpg'),
    web_06: require('./images/en/web_06.jpg'),
    web_07: require('./images/en/web_07.jpg'),
    web_08: require('./images/en/web_08.jpg'),
    web_09: require('./images/en/web_09.jpg'),
    web_10: require('./images/en/web_10.jpg'),
    logo: require('./images/logo.png'),
  },
});

export default images;
